import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _IconFileImageColor from './icon-file-image-color.vue';

const IconFileImageColor = Object.assign(_IconFileImageColor, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _IconFileImageColor.name, _IconFileImageColor);
  }
});

export default IconFileImageColor;
